import {
  Box,
  Button,
  Grid,
  InputLabel,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import { GLOBAL_STEPPER_DATA } from "../../../Redux/actions";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import Header from "./header";
import { CloudUpload } from "@material-ui/icons";
import { ObjectToFormdata } from "../../../Common/Utils/common_utils";
import AddToListModal from "../../../Components/FormGenerator/addToListModal";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import StepperService from "./StepperService";
import { mappedKeyJSON } from "./MappedKeyJSON";
import CustomSelectMulti from "../../../Components/CustomSelectMulti";
import CircularIndeterminate from "../../../Components/Loader";
import ImageCrop from "../../../Components/image-crop";

const GeneralProfile = (props: any) => {
  const classes = useStyles();
  const global_data = useSelector((state: any) => state.stepperReducer);
  const global_data_common = useSelector((state: any) => state.commonReducer);
  const dispatch = useDispatch();

  const data = {
    first_name: "",
    middle_name: "",
    last_name: "",
    suffix_id: "",
    city: "",
    country_list_id: "",
    background: "",
    educational_qualifications: "",
    development_and_supervision: "",
    personal_interest: "",
    coaching_approach: "",
    professional_approach: "",
    client_testimonials: "",
  };

  const [userData, setUserData] = useState(data);
  const [diagnosticToolsArr, setDiagnosticToolsArr]: any = useState([]);
  const [diagnosticTools_attribute, setDiagnosticTools_attribute]: any =
    useState([]);
  const [
    professionalAffiliationsListsArr,
    setProfessionalAffiliationsListsArr,
  ]: any = useState([]);
  const [
    professionalAffiliations_attribute,
    setProfessionalAffiliations_attribute,
  ]: any = useState([]);
  const [photoArr, setPhotoArr]: any = useState([]);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [showAddNewModalExist, setShowAddNewModalExist] = useState(false);
  const [addNewModalProps, setAddNewModalProps] = useState({});
  const [languageListsArr, setLanguageListsArr]: any = useState([]);
  const [languages_attribute, setLanguages_attribute]: any = useState([]);
  const [countryListsArr, setCountryListsArr]: any = useState([]);
  const [suffixArr, setSuffixArr]: any = useState([]);
  const [suffix_attribute, setSuffix_attribute]: any = useState([]);

  const [addNewFlag, setAddNewFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [imageBlob, setImageBlob]: any = useState(null);

    //  const globaluserData = useSelector((state) => state.commonReducer);
    //  const role = globaluserData?.role;
  let role = sessionStorage.getItem("role");

  const addNewHandler = (
    addNewModalExistFlag: any,
    modalFlag: any,
    addNewModalPropsData: any
  ) => {
    setShowAddNewModalExist(addNewModalExistFlag);
    setShowAddNewModal(modalFlag);
    setAddNewModalProps({ ...addNewModalProps, ...addNewModalPropsData });
  };
  const setInputState = (inputStateValue: any, inputId: any) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const onChangeItem = (
    selectedItemValue: any,
    inputId: any,
    routeFrom: any
  ) => {
    if (routeFrom == "add_in_drop_down") {
      setAddNewFlag(true);
    } else {
      setUserData({
        ...userData,
        [selectedItemValue.id]: selectedItemValue.value,
      });
    }
    console.log(selectedItemValue);
  };
  console.log("userDatatest :>> ", userData);
  const onChangeMultiItem = (
    obj: any,
    inputId: any,
    routeFrom: any,
    objId: any
  ) => {
    if (routeFrom == "add_in_drop_down") {
      if (inputId == "professional_affiliations") {
        setProfessionalAffiliations_attribute(
          professionalAffiliations_attribute.concat({
            id: objId,
            value: obj,
            label: obj,
          })
        );
      }
      if (inputId == "diagnosticTools_attributes") {
        setDiagnosticTools_attribute(
          diagnosticTools_attribute.concat({
            id: objId,
            value: obj,
            label: obj,
          })
        );
      }
      setAddNewFlag(true);
    } else {
      if (inputId == "diagnosticTools_attributes") {
        diagnosticTools_attribute.length = 0;
        setDiagnosticTools_attribute(diagnosticTools_attribute.concat(obj));
      }
      if (inputId == "professional_affiliations") {
        professionalAffiliations_attribute.length = 0;
        setProfessionalAffiliations_attribute(
          professionalAffiliations_attribute.concat(obj)
        );
      }

      if (inputId == "languages_attributes") {
        languages_attribute.length = 0;
        setLanguages_attribute(languages_attribute.concat(obj));
      }
      if (inputId == "suffix_attributes") {
        suffix_attribute.length = 0;
        setSuffix_attribute(suffix_attribute.concat(obj));
      }
    }
  };

  const updateData = () => {
    languageListsArr.length = 0;
    setLanguageListsArr(
      languageListsArr.concat(
        global_data_common.partnerDropdowns[mappedKeyJSON.Language]
      )
    );

    suffixArr.length = 0;
    setSuffixArr(
      suffixArr.concat(
        global_data_common.partnerDropdowns[mappedKeyJSON.Suffix]
      )
    );

    diagnosticToolsArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[mappedKeyJSON.DiagnosticTools],
      {
        id:
          global_data_common.partnerDropdowns[mappedKeyJSON.DiagnosticTools] +
          1,
        value: "+ Add New",
      },
    ];
    setDiagnosticToolsArr(diagnosticToolsArr.concat(pdata));

    professionalAffiliationsListsArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[
        mappedKeyJSON.ProfessionalAffiliation
      ],
      {
        id:
          global_data_common.partnerDropdowns[
            mappedKeyJSON.ProfessionalAffiliation
          ] + 1,
        value: "+ Add New",
      },
    ];
    setProfessionalAffiliationsListsArr(
      professionalAffiliationsListsArr.concat(pdata)
    );

    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.Country],
      setCountryListsArr,
      countryListsArr
    );

    if (!addNewFlag && global_data.general_profile_id != null) {
      setLoading(true);
      AdminPartnerClient.GeneralProfileField_get(
        global_data.general_profile_id,
        { partner_profile_id: global_data.partner_profile }
      )
        .then((response: any) => {
          console.log(response.data);
          photoArr.length = 0;
          if (response.data.attributes.photo.url != null) {
            var localArr = [];
            var pdata = {
              attributes: {
                created_at: response.data.attributes.created_at,
                file_name: response.data.attributes.file_name,
                url: response.data.attributes.photo.url,
              },
              id: 120,
            };
            // dispatch({
            //   type: GLOBAL_DATA,
            //   payload: {
            //     profile_logo: response.attributes.photo.url,
            //   },
            // })
            // global_data_common.profile_logo(response.data.attributes.photo.url)
            // sessionStorage.setItem("profile_logo", response.data.attributes.photo.url)
            localArr.push(pdata);
            setPhotoArr(photoArr.concat(localArr));
          }
          // sessionStorage.setItem("profile_logo", response.data.attributes.photo.url)

          setUserData({
            first_name: response.data.attributes.first_name,
            middle_name: response.data.attributes.middle_name,
            last_name: response.data.attributes.last_name,
            suffix_id: response.data.attributes.suffix_id,
            city: response.data.attributes.city,
            country_list_id: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.Country],
              response.data.attributes.country_list_id
            ),
            background: response.data.attributes.background,
            educational_qualifications:
              response.data.attributes.educational_qualifications,
            development_and_supervision:
              response.data.attributes.development_and_supervision,
            personal_interest: response.data.attributes.personal_interest,
            client_testimonials: response.data.attributes.client_testimonials,
            coaching_approach: "",
            professional_approach: "",
          });
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.partner_general_diagnostic_tools,
            global_data_common.partnerDropdowns[mappedKeyJSON.DiagnosticTools],
            setDiagnosticTools_attribute,
            diagnosticTools_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes
              .partner_general_info_professional_affiliations,
            global_data_common.partnerDropdowns[
              mappedKeyJSON.ProfessionalAffiliation
            ],
            setProfessionalAffiliations_attribute,
            professionalAffiliations_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.partner_general_languages,
            global_data_common.partnerDropdowns[mappedKeyJSON.Language],
            setLanguages_attribute,
            languages_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.partner_general_suffixes,
            global_data_common.partnerDropdowns[mappedKeyJSON.Suffix],
            setSuffix_attribute,
            suffix_attribute
          );
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };
  const firstElementRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
  }, []);
  useEffect(() => {
    updateData();
  }, [addNewFlag]);
  const [valuedAdded, setValueAdded] = useState({ added: false, value: null });
  useEffect(() => {
    if (valuedAdded?.added) {
      setValueAdded({ added: false, value: null });
      updateData();
    }
  }, [global_data_common.partnerDropdowns, valuedAdded.added]);
  const onSubmit = () => {
    var flag = true;

    if (role !== "admin") {
      if (userData.background.length === 0 || userData.background === "") {
        flag = false;
      }
      if (
        userData.educational_qualifications.length === 0 ||
        userData.educational_qualifications === ""
      ) {
        flag = false;
      }
      if (
        professionalAffiliations_attribute.length === 0 ||
        professionalAffiliations_attribute === ""
      ) {
        flag = false;
      }
    }

    if (flag) {
      console.log("languages_attribute", languages_attribute);
      var pLocalArr: any = [];
      var docResumeArr: any = [];
      var langArr: any =
        languages_attribute.length > 0
          ? languages_attribute.map((option: any) => option.id)
          : [];
      var suffixArr: any =
        suffix_attribute.length > 0
          ? suffix_attribute.map((option: any) => option.id)
          : [];
      var diagnostic_toolArr: any =
        diagnosticTools_attribute[0] != undefined &&
        diagnosticTools_attribute.map((option: any) => option.id);
      var professionalAffiliations_Arr: any =
        professionalAffiliations_attribute[0] != undefined &&
        professionalAffiliations_attribute.map((option: any) => option.id);
      photoArr.map((option: any) => {
        option.attributes.document &&
          docResumeArr.push(option.attributes.document);
      });

      setSubmitClickFlag(false);

      console.log(
        "professionalAffiliations_attribute",
        professionalAffiliations_attribute
      );

      var postData = {
        ...userData,
        country_list_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.Country],
          userData.country_list_id
        ),
        photo: docResumeArr[0],
        suffix_id: suffixArr.length > 0 ? JSON.stringify(suffixArr) : "[]",
        language_list_id: langArr.length > 0 ? JSON.stringify(langArr) : "[]",
        professional_affiliation_id:
          professionalAffiliations_Arr.length > 0
            ? JSON.stringify(professionalAffiliations_Arr)
            : "[]",
        diagnostic_tool_id:
          diagnostic_toolArr.length > 0
            ? JSON.stringify(diagnostic_toolArr)
            : "[]",
        remove_photo: docResumeArr[0] == undefined ? true : false,
      };
      console.log(postData);
      setLoading(true);

      if (global_data.general_profile_id == null) {
        AdminPartnerClient.GeneralProfileField(
          ObjectToFormdata({
            partner_profile_id: global_data.partner_profile,
            ...postData,
          })
        )
          .then((response: any) => {
            dispatch({
              type: GLOBAL_STEPPER_DATA,
              payload: { general_profile_id: response.data.id },
            });
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information saved successfully"])
            );
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        AdminPartnerClient.GeneralProfileField_put(
          global_data.general_profile_id,
          ObjectToFormdata({
            partner_profile_id: global_data.partner_profile,
            ...postData,
          })
        )
          .then(() => {
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information updated successfully"])
            );
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    } else {
      setSubmitClickFlag(true);
    }
  };
  const onImageChange = (event: any) => {
    var localArr = [];
    var pdata = {
      attributes: {
        document: event.target.files[0],
        created_at: "2021-04-08T12:06:08.000Z",
        file_name: event.target.files[0].name,
      },
      id: photoArr.length + 1,
    };
    localArr.push(pdata);
    setPhotoArr(photoArr.concat(localArr));
  };

  const onBack = () => {
    props.parentHandleNext(props.activeIndex - 1);
  };

  return (
    <div style={{ marginBottom: 40 }} ref={firstElementRef}>
      <Grid
        container
        direction='row'
        alignItems='center'
        style={{ padding: 30, marginBottom: 30 }}
      >
        <Grid item xs={10}>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                {/* Upload photo{role != "admin" ? "*" : ""} */}
                Upload photo
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <label htmlFor='upload-photo-resume'>
                <input
                  onChange={(e) => {
                    onImageChange(e);
                  }}
                  accept='*'
                  style={{ display: "none" }}
                  id='upload-photo-resume'
                  name='upload-photo'
                  type='file'
                />
                <Button
                  disableElevation
                  color='secondary'
                  variant='contained'
                  component='span'
                  style={{ fontSize: 12 }}
                >
                  <CloudUpload style={{ marginRight: 10 }} />
                  Upload
                </Button>
                {/* {submitClickFlag && photoArr.length == 0 && (
                  <Typography variant="body1" style={{ color: "red" }}>
                    <Box>Please upload photo</Box>
                  </Typography>
                )} */}
              </label>
            </Grid>
          </Grid>
          <Grid container direction='row' alignItems='center'>
            <Grid item xs={4}></Grid>
            <Grid item xs={8}>
              {StepperService.uploadImageCard(
                photoArr,
                setPhotoArr,
                "/partner_contract_documents/",
                null,
                dispatch
              )}
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>First name</Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='first_name'
                variant='outlined'
                placeholder='First name'
                helperText={
                  submitClickFlag && userData.first_name == ""
                    ? "Please enter first name"
                    : ""
                }
                error={
                  submitClickFlag && userData.first_name == "" ? true : false
                }
                parentcall={setInputState}
                value={userData.first_name}
              />
            </Grid>
          </Grid>
          {role === "admin" && (
            <Grid
              container
              direction='row'
              alignItems='center'
              style={{ marginBottom: 30 }}
            >
              <Grid item xs={4}>
                <Typography variant='h2'>Middle name</Typography>
              </Grid>
              <Grid item xs={8}>
                <CustomInput
                  id='middle_name'
                  variant='outlined'
                  placeholder='Middle name'
                  helperText={
                    submitClickFlag && userData.middle_name == ""
                      ? "Please enter middle name"
                      : ""
                  }
                  error={
                    submitClickFlag && userData.middle_name == "" ? true : false
                  }
                  parentcall={setInputState}
                  value={userData.middle_name}
                />
              </Grid>
            </Grid>
          )}
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>Last name</Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='last_name'
                variant='outlined'
                placeholder='Last name'
                helperText={
                  submitClickFlag && userData.last_name == ""
                    ? "Please enter last name"
                    : ""
                }
                error={
                  submitClickFlag && userData.last_name == "" ? true : false
                }
                parentcall={setInputState}
                value={userData.last_name}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>Full name</Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='full_name'
                variant='outlined'
                placeholder='Full name'
                disabled
                value={
                  userData.first_name != ""
                    ? `${userData.first_name} ${userData.middle_name} ${userData.last_name}`
                    : ""
                }
                defaultValue={userData.first_name}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>Suffix</Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelectMulti
                id='suffix_attributes'
                itemArr={suffixArr}
                parentcall={onChangeMultiItem}
                placeholder='Select suffix'
                value={suffix_attribute}
                defaultValue={userData.country_list_id}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                City
                {/* City{role != "admin" ? "*" : ""} */}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='city'
                variant='outlined'
                placeholder='City'
                parentcall={setInputState}
                value={userData.city}
                defaultValue={userData.city}
                // helperText={
                //   role != "admin" && submitClickFlag && userData.city == ""
                //     ? "Please enter office city"
                //     : ""
                // }
                // error={
                //   role != "admin" && submitClickFlag && userData.city == ""
                //     ? true
                //     : false
                // }
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Country
                {/* Country{role != "admin" ? "*" : ""} */}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelect
                id='country_list_id'
                labelText='Select country'
                displayEmpty
                variant='outlined'
                itemArr={countryListsArr}
                parentcall={onChangeItem}
                // helperText={
                //   role != "admin" &&
                //   submitClickFlag &&
                //   (userData.country_list_id == "" ||
                //     userData.country_list_id == undefined)
                //     ? "Please select office county"
                //     : ""
                // }
                // error={
                //   role != "admin" &&
                //   submitClickFlag &&
                //   userData.country_list_id == ""
                //     ? true
                //     : false
                // }
                defaultValue={userData.country_list_id}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Background/Career history{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='background'
                multiline={true}
                rows={4}
                variant='outlined'
                placeholder='Background/Career history'
                helperText={
                  submitClickFlag && userData.background == ""
                    ? "Please enter background"
                    : ""
                }
                error={
                  submitClickFlag && userData.background == "" ? true : false
                }
                parentcall={setInputState}
                value={userData.background}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Education and qualifications{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='educational_qualifications'
                variant='outlined'
                multiline={true}
                rows={4}
                placeholder='Education and qualifications'
                parentcall={setInputState}
                helperText={
                  role !== "admin" &&
                  submitClickFlag &&
                  userData.educational_qualifications == ""
                    ? "Please enter education and qualification"
                    : ""
                }
                error={
                  role !== "admin" &&
                  submitClickFlag &&
                  userData.educational_qualifications == ""
                    ? true
                    : false
                }
                value={userData.educational_qualifications}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Professional development and supervision
                {/* {role != "admin" ? "*" : ""} */}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='development_and_supervision'
                variant='outlined'
                placeholder='Professional development and supervision'
                multiline={true}
                rows={4}
                // helperText={
                //   submitClickFlag && userData.development_and_supervision == ""
                //     ? "Please enter professional development and supervision"
                //     : ""
                // }
                // error={
                //   submitClickFlag && userData.development_and_supervision == ""
                //     ? true
                //     : false
                // }
                parentcall={setInputState}
                value={userData.development_and_supervision}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Professional affiliations{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelectMulti
                id='professional_affiliations'
                itemArr={professionalAffiliationsListsArr}
                drop_down='ProfessionalAffiliation'
                addNewHandler={addNewHandler}
                field_name='professional_affiliation'
                addNewFlag={true}
                setValueAdded={setValueAdded}
                parentcall={onChangeMultiItem}
                placeholder='Select professional affiliations'
                helperText={
                  role != "admin" &&
                  submitClickFlag &&
                  professionalAffiliations_attribute.length == 0
                    ? "Please select professional affiliations"
                    : ""
                }
                error={
                  role != "admin" &&
                  submitClickFlag &&
                  professionalAffiliations_attribute.length == 0
                    ? true
                    : false
                }
                value={professionalAffiliations_attribute}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Languages
                {/* Languages{role != "admin" ? "*" : ""} */}
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <CustomSelectMulti
                id='languages_attributes'
                itemArr={languageListsArr}
                parentcall={onChangeMultiItem}
                placeholder='Select languages'
                // helperText={
                //   submitClickFlag && languages_attribute.length == 0
                //     ? "Please select languages"
                //     : ""
                // }
                // error={
                //   submitClickFlag && languages_attribute.length == 0
                //     ? true
                //     : false
                // }
                value={languages_attribute}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Psychometric and diagnostic tools
                {/* Psychometric and diagnostic tools{role != "admin" ? "*" : ""} */}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelectMulti
                id='diagnosticTools_attributes'
                itemArr={diagnosticToolsArr}
                drop_down='DiagnosticTool'
                addNewHandler={addNewHandler}
                field_name='diagnostic_tool'
                addNewFlag={true}
                setValueAdded={setValueAdded}
                parentcall={onChangeMultiItem}
                placeholder='Select psychometric and diagnostic tools'
                // helperText={
                //   submitClickFlag && diagnosticTools_attribute.length == 0
                //     ? "Please select psychometric and diagnostic tools"
                //     : ""
                // }
                // error={
                //   submitClickFlag && diagnosticTools_attribute.length == 0
                //     ? true
                //     : false
                // }
                value={diagnosticTools_attribute}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Personal interests
                {/* Personal interests{role != "admin" ? "*" : ""} */}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='personal_interest'
                variant='outlined'
                placeholder='Personal interests'
                parentcall={setInputState}
                multiline={true}
                rows={4}
                // helperText={
                //   submitClickFlag && userData.personal_interest == ""
                //     ? "Please enter personal interests"
                //     : ""
                // }
                // error={
                //   submitClickFlag && userData.personal_interest == ""
                //     ? true
                //     : false
                // }
                value={userData.personal_interest}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Client testimonials
                {/* Client testimonials{role != "admin" ? "*" : ""} */}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='client_testimonials'
                variant='outlined'
                multiline={true}
                rows={4}
                placeholder='Client testimonials'
                parentcall={setInputState}
                value={userData.client_testimonials}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Header
        saveBtnTitle={"Save & Proceed"}
        isBack={true}
        parentcall={onSubmit}
        parentBackCall={onBack}
      />
      {showAddNewModalExist && showAddNewModal && (
        <AddToListModal
          type='partner_profiles'
          postData={{ ...addNewModalProps }}
        />
      )}
      {loading && <CircularIndeterminate />}
    </div>
  );
};
export default GeneralProfile;
const useStyles = makeStyles(() => ({
  labelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
    paddingRight: "10px",
  },
  uploadLabelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
    paddingRight: "10px",
    marginTop: "14px",
  },
}));
